// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tableBox[data-v-e4a673fa]{height:calc(100% - 260px)}.colorStyle[data-v-e4a673fa]{color:red}.formbox[data-v-e4a673fa] ,.headebut[data-v-e4a673fa]{width:60%;margin:0 auto}.headebut[data-v-e4a673fa]{padding-left:100px;box-sizing:border-box}", ""]);
// Exports
module.exports = exports;
